import SvgIcon from './SvgIcon';

const SelectIcon = (props) => (
  <SvgIcon
    {...props}
    width="13px"
    height="8px"
    viewBox="0 0 13 8"
    version="1.1">
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-1088.000000, -685.000000)">
      <g
        transform="translate(152.000000, 200.000000)"
        fill={props.fill}
        fillRule="nonzero">
        <g transform="translate(723.000000, 42.500000)">
          <g transform="translate(1.000000, 388.000000)">
            <path
              d="M223.347375,61.7242265 C223.725436,62.0785912 224.338394,62.0785912 224.716454,61.7242265 C225.094515,61.3698619 225.094515,60.7953233 224.716454,60.4409587 L219.18454,55.2557735 C218.806479,54.9014088 218.193521,54.9014088 217.81546,55.2557735 L212.283546,60.4409587 C211.905485,60.7953233 211.905485,61.3698619 212.283546,61.7242265 C212.661606,62.0785912 213.274564,62.0785912 213.652625,61.7242265 L218.502648,57.1781936 L223.347375,61.7242265 Z"
              id="Shape-Copy-4"
              transform="translate(218.500000, 58.490000) rotate(180.000000) translate(-218.500000, -58.490000) "
            />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

SelectIcon.defaultProps = {
  fill: '#414953',
};

export default SelectIcon;
